module.exports = __webpack_public_path__ + "static/media/November2020Newsletter.71c438bb.pdf";